import React, { useState, useEffect, useRef, useCallback } from 'react';
import './DetailComponents.css';

const EditAssociateModal = ({ associate, index, onSave, onClose }) => {
  const [editedAssociate, setEditedAssociate] = useState({ ...associate });
  const modalRef = useRef(null);

  const handleClickOutside = useCallback((event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);

  const handleSave = () => {
    onSave(editedAssociate, index);
  };

  const relationships = ['Spouse', 'Partner', 'Son', 'Daughter', 'Father', 'Mother', 'Brother', 'Sister', 'Friend', 'Other'];

  return (
    <div className="modal-overlay">
      <div className="modal edit-modal" ref={modalRef}>
        <h3>Edit Travel Associate</h3>
        <div className="edit-modal-form">
          <div className="edit-modal-field">
            <label className="edit-modal-label">Name:</label>
            <input
              className="edit-modal-input"
              value={editedAssociate.name}
              onChange={e => setEditedAssociate({ ...editedAssociate, name: e.target.value })}
            />
          </div>
          <div className="edit-modal-field">
            <label className="edit-modal-label">Relationship:</label>
            <select
              className="edit-modal-input"
              value={editedAssociate.relationship}
              onChange={e => setEditedAssociate({ ...editedAssociate, relationship: e.target.value })}
            >
              {relationships.map(rel => (
                <option key={rel} value={rel}>{rel}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="modal-actions">
          <button className="modal-action-button" onClick={onClose}>Cancel</button>
          <button className="modal-action-button" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default EditAssociateModal;